/* src/app/home-new/files-container/files-container.component.scss */
::-webkit-scrollbar {
  width: 3px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #ffffff;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: var(--ion-color-primary);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: #b7b7b7;
}
.files-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}
mat-grid-tile {
  overflow: visible;
}
.file-container {
  width: 100%;
  height: 100%;
}
.file-container .title {
  white-space: nowrap;
}
.file-container:active {
  cursor: url(/src/assets/icon/drag-click.svg), move !important;
}
.file-drag-preview {
  max-height: 380px;
}
@media (max-width: 1104px) {
  .file-drag-preview {
    max-height: 100px;
  }
}
.cdk-drag-placeholder {
  opacity: 0;
  width: 100% !important;
  max-height: 100px;
  display: block;
  width: 100%;
  height: 100%;
}
.add-opacity {
  opacity: 0.3;
}
.hidden-placeholder {
  height: 1px;
  width: 1px;
  margin: 0;
  padding: 0;
  border: none;
  visibility: hidden;
}
.no-transform {
  transform: none !important;
  -webkit-user-select: none;
  user-select: none;
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.grouped-file-list .title {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  font-size: 18px;
  width: 100%;
}
.warningMessage {
  border-radius: 15px;
  border: 2px solid #f5b200;
  background:
    linear-gradient(
      0deg,
      rgba(245, 178, 0, 0.1) 0%,
      rgba(245, 178, 0, 0.1) 100%),
    #fff;
  padding: 12px 15px;
  align-items: center;
  width: fit-content;
  top: 0;
  z-index: 9;
}
.warningMessage ion-icon {
  width: 30px;
  height: 30px;
  color: #d59b00;
}
.warningMessage span {
  color: #d59b00;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  white-space: pre-wrap;
  text-align: start;
}
@media (min-width: 1105px) {
  .warningMessage {
    position: sticky;
  }
}
/*# sourceMappingURL=files-container.component-AJYPAUES.css.map */
